import Addressbook from 'containers/Addressbook/reducer'
import AddressbookSaga from 'containers/Addressbook/saga'
import { redux as AddressBookNew } from 'containers/AddressBookNew'
import { redux as AddressBookOrder } from 'containers/AddressBookOrder'
import { redux as AddressBookShared } from 'containers/AddressBookShared'
import AddressModal from 'containers/AddressModal/reducer'
import AddressModalSaga from 'containers/AddressModal/saga'
// AddressSearchInput
import AddressSearchInput from 'containers/AddressSearchInput/reducer'
import AddressSearchInputSaga from 'containers/AddressSearchInput/saga'
// AddressVoiceSearch
import AddressVoiceSearch from 'containers/AddressVoiceSearch/reducer'
import AddressVoiceSearchSaga from 'containers/AddressVoiceSearch/saga'
import CitySearchInput from 'containers/CitySearchInput/reducer'
import CitySearchInputSaga from 'containers/CitySearchInput/saga'
import { redux as CronOrders } from 'containers/CronOrdersList'
import CronOrder from 'containers/CronOrdersList/reducer'
import CronOrderSaga from 'containers/CronOrdersList/saga'
import { redux as Customs } from 'containers/Customs'
import { redux as OrdersRedux } from 'containers/OrderList'
import Orders from 'containers/OrderList/reducer'
import OrdersSaga from 'containers/OrderList/saga'
import { applyMiddleware, combineReducers, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'

const rootSaga = createSagaMiddleware({
  onError: (error, second) => {
    // if (global.BUILD_COMMIT !== 'master') {
    //   Sentry.captureException(error)
    // }
  },
})
const reducers = {
  AddressSearchInput,
  CitySearchInput,
  Addressbook,
  AddressModal,
  // Products,
  AddressVoiceSearch,
  Orders,
  CronOrder,
  // AddressBookNew,
  ...AddressBookNew.mappedReducers,
  ...OrdersRedux.mappedReducers,
  ...Customs.mappedReducers,
  ...AddressBookOrder.mappedReducers,
  ...CronOrders.mappedReducers,
  ...AddressBookShared.mappedReducers,
}

const rootReducer = combineReducers(reducers)

const store = createStore(rootReducer, {}, applyMiddleware(rootSaga))

rootSaga.run(AddressSearchInputSaga)
rootSaga.run(CitySearchInputSaga)
rootSaga.run(AddressbookSaga)
rootSaga.run(AddressModalSaga)
// rootSaga.run(ProductsSaga)
rootSaga.run(OrdersSaga)
rootSaga.run(AddressVoiceSearchSaga)
rootSaga.run(CronOrderSaga)
AddressBookShared.runSagas(rootSaga)

OrdersRedux.runSagas(rootSaga)
AddressBookNew.runSagas(rootSaga)
Customs.runSagas(rootSaga)
AddressBookOrder.runSagas(rootSaga)
CronOrders.runSagas(rootSaga)

export default store
